<template>
  <section class="section container pt-0">
    <report-datatable />
  </section>
</template>

<script>
import ReportDatatable from "./report_datatable/Index.vue";

export default {
  name: "ReportIndex",
  components: {
    ReportDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
